import { FpsCounter } from '@/components/shared/FpsCounter';
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { DevToolsDisabler } from "@/components/dev-tools-disabler";
import { AppProviders } from "@app/providers/AppProviders";
import { AppRouter } from "@app/router/AppRouter";

function CompactLandscapeNotice() {
  const { t } = useTranslation();

  return (
    <div className="landscape-notice">
      <div className="phone" />
      <div className="message">
        <p className="landscape-notice__title">{t("app.tiltDetected")}</p>
        <p className="landscape-notice__subtitle">{t("app.switchToPortrait")}</p>
      </div>
    </div>
  );
}


const SHOW_FPS = new URLSearchParams(window.location.search).has('fps');
export default function App() {
  const [isCompactLandscape, setIsCompactLandscape] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia(
      "(orientation: landscape) and (max-height: 610px)",
    );
    const handleChange = (event: MediaQueryListEvent) => {
      setIsCompactLandscape(event.matches);
    };
    setIsCompactLandscape(mediaQuery.matches);
    mediaQuery.addEventListener("change", handleChange);
    return () => mediaQuery.removeEventListener("change", handleChange);
  }, []);

  return (
    <AppProviders>
      <>
        <DevToolsDisabler />
        <AppRouter />
        {isCompactLandscape && <CompactLandscapeNotice />}
      </>
    
      {SHOW_FPS && <FpsCounter />}
    </AppProviders>
  );
}
